import { setSpecificMessage, notWords } from "valibot";
setSpecificMessage(
  notWords,
  (issue) => `Mots invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);